<template>
  <div class="page">

    <!-- 顶部栏 -->
    <header class="topbar">
      <div class="tb-back" @click="$router.back()">
        <i class="fa-solid fa-chevron-left"></i>
      </div>
      <h1 class="tb-title">{{ categoryName }} · 商户列表</h1>
      <div class="tb-spacer"></div>
    </header>

    <!-- 顶部筛选 -->
    <div class="filter-bar">
      <div
        v-for="f in filters"
        :key="f.key"
        class="filter-tag"
        :class="{ active: activeFilter === f.key }"
        @click="switchFilter(f.key)"
      >
        {{ f.label }}
      </div>
    </div>

    <!-- 商户列表 -->
    <div class="shop-list">
      <router-link
        v-for="m in shopList"
        :key="m.id"
        :to="`/shop/${m.id}`"
        class="shop-row"
      >
        <div class="sr-img" :style="{ background: shopBg(m.category?.name) }">
          <img
            v-if="m.main_image"
            :src="imgUrl(m.main_image)"
            :alt="m.name"
            @error="e => handleImgError(e, m)"
          />
          <div v-else class="sr-img-default">
            <i :class="shopIcon(m.category?.name)"></i>
            <span class="sr-img-text">{{ m.name?.substring(0, 2) || '商户' }}</span>
          </div>
        </div>
        <div class="sr-info">
          <div class="sr-top">
            <h4 class="sr-name">{{ m.name }}</h4>
            <!-- <div class="sr-rating">
              <i class="fa-solid fa-star"></i>
              <span>{{ m.rating }}</span>
            </div> -->
          </div>
          <p class="sr-loc">
            <i class="fa-solid fa-location-dot"></i>
            {{ m.town?.name }} · {{ m.address }}
          </p>
          <div class="sr-bottom">
            <div v-if="m.coupon" class="sr-coupon">
              <span class="sr-cpn">
                <i class="fa-solid fa-ticket"></i>
                <span class="sr-cpn-content">
                  <span v-for="(line, idx) in formatDesc(m.coupon.name || '满' + m.coupon.threshold + '减' + m.coupon.reduce_amount)" :key="idx" class="sr-cpn-line">{{ line }}</span>
                </span>
              </span>
              <div class="sr-cpn-meta">
                <span v-if="m.coupon.valid_end" class="sr-cpn-date"><i class="fa-regular fa-calendar"></i> {{ m.coupon.valid_end }}</span>
                <!-- <span v-if="m.coupon.remainQuota !== undefined" class="sr-cpn-remain"><i class="fa-solid fa-fire"></i> 剩余{{ m.coupon.remainQuota }}张</span> -->
              </div>
              <span v-if="m.coupon.description" class="sr-cpn-desc">
                <i class="fa-solid fa-circle-info"></i>
                <span class="sr-cpn-desc-content">
                  <span v-for="(line, idx) in formatDesc(m.coupon.description)" :key="idx" class="sr-cpn-desc-line">{{ line }}</span>
                </span>
              </span>
            </div>
            <span v-if="m.support_trade_in" class="sr-trade">以旧换新</span>
          </div>
        </div>
      </router-link>

      <!-- 加载更多 -->
      <div v-if="loading" class="loading">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <span>加载中...</span>
      </div>

      <div v-if="!loading && noMore && shopList.length > 0" class="no-more">
        — 没有更多了 —
      </div>

      <!-- 空状态 -->
      <div v-if="!loading && shopList.length === 0" class="empty">
        <i class="fa-solid fa-store-slash"></i>
        <p>暂无相关商户</p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'CategoryShops',

  data() {
    return {
      shopList: [],
      loading: false,
      noMore: false,
      page: 1,
      pageSize: 10,
      activeFilter: 'all',

      filters: [
        // { key: 'all', label: '吴川市' },
        // { key: 'distance', label: '距离最近' },
        // { key: 'rating', label: '评分最高' },
        // { key: 'sales', label: '销量最高' }
      ],

      shopFaIcons: {
        '餐饮美食': 'fa-solid fa-shrimp',
        '商超便利': 'fa-solid fa-store',
        '电器数码': 'fa-solid fa-tv',
        '家居建材': 'fa-solid fa-couch',
        '汽车服务': 'fa-solid fa-car',
        '美容美发': 'fa-solid fa-scissors',
        '休闲娱乐': 'fa-solid fa-gamepad',
        '医疗健康': 'fa-solid fa-heart-pulse'
      },

      shopColors: {
        '餐饮美食': '#fff7ed',
        '商超便利': '#eff6ff',
        '电器数码': '#eff6ff',
        '家居建材': '#fdf4ff',
        '汽车服务': '#f0fdf4',
        '美容美发': '#fdf2f8',
        '休闲娱乐': '#fefce8',
        '医疗健康': '#fef2f2'
      }
    }
  },

  computed: {
    categoryId() {
      return this.$route.params.categoryId
    },
    categoryName() {
      return this.$route.query.name || '行业'
    }
  },

  mounted() {
    this.fetchShops(true)
    window.addEventListener('scroll', this.handleScroll)
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    formatDesc(text) {
      if (!text) return []
      // 把 "1. xxx 2. yyy" 或 "一、xxx 二、yyy" 拆成多行，普通文本保持不变
      return text.split(/(?=(?:\d+\.[^\d]|[一二三四五六七八九十]+、))/).map(s => s.trim()).filter(Boolean)
    },

    async fetchShops(reset = false) {
      if (this.loading) return
      if (reset) {
        this.page = 1
        this.noMore = false
        this.shopList = []
      }
      if (this.noMore) return

      this.loading = true
      try {
        let url = `/api/v1/merchants?categoryId=${this.categoryId}&page=${this.page}&pageSize=${this.pageSize}`
        if (this.activeFilter === 'rating') url += '&sort=rating'
        if (this.activeFilter === 'sales') url += '&sort=view_count'

        const r = await this.$api.get(url)
        const list = r.data.data?.list || []

        if (reset) {
          this.shopList = list
        } else {
          this.shopList.push(...list)
        }

        if (list.length < this.pageSize) {
          this.noMore = true
        } else {
          this.page++
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },

    switchFilter(key) {
      this.activeFilter = key
      this.fetchShops(true)
    },

    handleScroll() {
      // 检查是否滚动到底部
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      const clientHeight = document.documentElement.clientHeight || window.innerHeight

      // 当滚动到距离底部 100px 时触发加载
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        this.fetchShops(false)
      }
    },

    imgUrl(path) {
      if (!path) return ''
      if (path.startsWith('http')) return path
      const base = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000'
      return base + (path.startsWith('/') ? path : '/' + path)
    },

    shopIcon(cat) {
      return this.shopFaIcons[cat] || 'fa-solid fa-store'
    },

    shopBg(cat) {
      return this.shopColors[cat] || '#f3f4f6'
    },

    handleImgError(e, merchant) {
      e.target.style.display = 'none'
      const parent = e.target.parentElement
      if (parent && !parent.querySelector('.sr-img-default')) {
        const defaultDiv = document.createElement('div')
        defaultDiv.className = 'sr-img-default'
        defaultDiv.innerHTML = `
          <i class="${this.shopIcon(merchant.category?.name)}"></i>
          <span class="sr-img-text">${merchant.name?.substring(0, 2) || '商户'}</span>
        `
        parent.appendChild(defaultDiv)
      }
    }
  }
}
</script>

<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css');

*, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

.page {
  width: 100%;
  min-height: 100vh;
  background: #f4f8fb;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'PingFang SC', 'Microsoft YaHei', sans-serif;
  color: #1f2937;
  padding-top: 48px;
}

/* ================================================================
   顶部栏
   ================================================================ */
.topbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  height: 48px;
  padding: 0 12px;
  background: #fff;
  border-bottom: 1px solid #f3f4f6;
}

.tb-back {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
  color: #1f2937;
}

.tb-back:active { background: #f3f4f6; }
.tb-back i { font-size: 14px; }

.tb-title {
  flex: 1;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
}

.tb-spacer { width: 32px; }

/* ================================================================
   筛选栏
   ================================================================ */
.filter-bar {
  position: sticky;
  top: 48px;
  z-index: 99;
  display: flex;
  gap: 8px;
  padding: 12px 16px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  background: #f4f8fb;
}

.filter-bar::-webkit-scrollbar { display: none; }

.filter-tag {
  flex-shrink: 0;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
  background: #fff;
  border: 1px solid #e5e7eb;
  cursor: pointer;
  transition: all .2s;
}

.filter-tag.active {
  background: #0167CC;
  color: #fff;
  border-color: #0167CC;
}

.filter-tag:active { transform: scale(.95); }

/* ================================================================
   商户列表
   ================================================================ */
.shop-list {
  padding: 0 12px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.shop-row {
  display: flex;
  gap: 12px;
  background: #fff;
  border-radius: 12px;
  padding: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,.04);
  text-decoration: none;
  color: inherit;
  transition: transform .2s;
}

.shop-row:active { transform: scale(.99); }

.sr-img {
  width: 80px;
  height: 80px;
  min-width: 80px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.sr-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.sr-img i {
  font-size: 28px;
  color: #d1d5db;
}

.sr-img-default {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #9ca3af;
}

.sr-img-default i {
  font-size: 24px;
  color: #0167CC;
  opacity: 0.6;
  margin-bottom: 4px;
}

.sr-img-text {
  font-size: 10px;
  font-weight: 600;
  color: #6b7280;
  max-width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sr-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
}

.sr-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.sr-name {
  font-size: 14px;
  font-weight: 700;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 8px;
}

.sr-rating {
  display: flex;
  align-items: center;
  gap: 3px;
  flex-shrink: 0;
}

.sr-rating i { font-size: 10px; color: #f59e0b; }
.sr-rating span { font-size: 12px; font-weight: 700; color: #f59e0b; }

.sr-loc {
  font-size: 11px;
  color: #9ca3af;
  margin-top: 3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sr-loc i { font-size: 9px; margin-right: 2px; }

.sr-bottom {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  flex-wrap: wrap;
}

.sr-cpn {
  display: inline-flex;
  align-items: flex-start;
  gap: 3px;
  font-size: 9px;
  padding: 2px 6px;
  border: 1px solid #fecaca;
  color: #ef4444;
  background: #fef2f2;
  border-radius: 4px;
  font-weight: 500;
  line-height: 1.45;
  text-align: left;
}

.sr-cpn-content {
  display: flex;
  flex-direction: column;
}

.sr-cpn-line {
  display: block;
  text-align: left;
}

.sr-cpn i {
  font-size: 8px;
}

.sr-coupon {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.sr-cpn-meta {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.sr-cpn-date,
.sr-cpn-remain {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 9px;
  color: #9ca3af;
}

.sr-cpn-date i { color: #60a5fa; }
.sr-cpn-remain i { color: #f97316; }

.sr-cpn-desc {
  display: inline-flex;
  align-items: flex-start;
  gap: 3px;
  font-size: 9px;
  color: #9ca3af;
  line-height: 1.45;
  text-align: left;
}

.sr-cpn-desc-content {
  display: flex;
  flex-direction: column;
}

.sr-cpn-desc-line {
  display: block;
  text-align: left;
}

.sr-cpn-desc i {
  font-size: 8px;
  flex-shrink: 0;
  margin-top: 1.5px;
}

.sr-trade {
  font-size: 9px;
  padding: 2px 6px;
  border: 1px solid #bfdbfe;
  color: #0167CC;
  background: #eff6ff;
  border-radius: 4px;
  font-weight: 500;
}

.sr-sale {
  font-size: 10px;
  color: #9ca3af;
  margin-left: auto;
}

/* ================================================================
   加载 / 空状态
   ================================================================ */
.loading, .empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  color: #9ca3af;
}

.loading i, .empty i {
  font-size: 32px;
  margin-bottom: 8px;
  opacity: .5;
}

.no-more {
  text-align: center;
  padding: 16px 0;
  font-size: 12px;
  color: #d1d5db;
}

/* ================================================================
   响应式
   ================================================================ */
@media (max-width: 360px) {
  .sr-img { width: 68px; height: 68px; min-width: 68px; }
  .sr-name { font-size: 13px; }
}

@media (min-width: 481px) {
  .shop-list { padding: 0 16px 24px; }
  .sr-img { width: 90px; height: 90px; min-width: 90px; }
  .sr-name { font-size: 15px; }
}
</style>
